import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
}
export function Description(props: Props) {
  const { children, align = 'left' } = props
  return (
    <Typography variant="body2" color="text.secondary" align={align}>
      {children}
    </Typography>
  )
}
